import { isClientEnv } from '@app/src/utils/validations';

const validExistsToken = async (rep) => {
    const sleep = ms => new Promise(res => setTimeout(res, ms));

    for await (const i of [...Array(rep)].map((_, i) => i)) {
        const appStorage = isClientEnv() && JSON.parse(localStorage.getItem('app'));
        const jwt = appStorage && appStorage.jwt;
        if (jwt !== null) {
            console.log('token app obtenido', jwt);
            break;
        }
        await sleep(1000);
        console.log(`Waited[${i}] 1 sec`);
        if (jwt === null)
        console.log('sin token app en storage');
    }
}

export default validExistsToken